import { useSearchParams } from "react-router";
import { HokodoSellarCreditStatement } from "./HokodoSellarCreditStatement/HokodoSellarCreditStatement";
import { TwoSellarCreditStatement } from "./TwoSellarCreditStatement/TwoSellarCreditStatement";

export const SellarCreditStatement = () => {
  const [searchParams] = useSearchParams();
  const provider = searchParams.get("provider");

  if (provider === "hokodo") {
    return <HokodoSellarCreditStatement />;
  }

  return <TwoSellarCreditStatement />;
};
